import axios from 'axios';
import authHeader from './auth-header';
import Config from '../config/index';

class PermissionService {
    async getPermissionList() {
        const response = await axios.get(Config.apiBasePath + '/getPermissionList', { headers: authHeader() });
        return response;
    }
    async getPermissionsByRoleID(id) {
        const response = await axios.get(Config.apiBasePath + '/getPermissionByRole/' + id, { headers: authHeader() });
        return response;
    }
    async savePermissionOfRole(data) {
        const response = await axios.post(Config.apiBasePath + '/setRolePermission', data, { headers: authHeader() });
        return response;
    }
    async getUserPermissions() {
        const response = await axios.get(Config.apiBasePath + '/getRolePermissions', { headers: authHeader() });
        if (response.status == 200) {
            var permissionMap = {
                READ_CONTENT: "N",
                UPDATE_CONTENT: "N",
                DELETE_CONTENT: "N",
                PUBLISH_CONTENT: "N",
                UPDATE_USERS: "N",
                DELETE_USERS: "N",
                MANAGE_ROLES: "N",
                ADD_CONTENT: "N",
                SHOW_NOTIFICATIONS: "N",
            };
            response.data.forEach(permission => {
                switch (permission.permission_name) {
                    case "READ_CONTENT":
                        permissionMap.READ_CONTENT = permission.permission_yn;
                        break;
                    case "DELETE_USERS":
                        permissionMap.DELETE_USERS = permission.permission_yn;
                        break;
                    case "UPDATE_USERS":
                        permissionMap.UPDATE_USERS = permission.permission_yn;
                        break;
                    case "PUBLISH_CONTENT":
                        permissionMap.PUBLISH_CONTENT = permission.permission_yn;
                        break;
                    case "DELETE_CONTENT":
                        permissionMap.DELETE_CONTENT = permission.permission_yn;
                        break;
                    case "ADD_CONTENT":
                        permissionMap.ADD_CONTENT = permission.permission_yn;
                        break;
                    case "UPDATE_CONTENT":
                        permissionMap.UPDATE_CONTENT = permission.permission_yn;
                        break;
                    case "MANAGE_ROLES":
                        permissionMap.MANAGE_ROLES = permission.permission_yn;
                        break;
                    case "SHOW_NOTIFICATIONS":
                        permissionMap.SHOW_NOTIFICATIONS = permission.permission_yn;
                        break;
                    default:
                        permissionMap[permission.permission_name] = permission.permission_yn;
                        break;
                }
            });
            localStorage.setItem("permissions", JSON.stringify(permissionMap));
        }
        return response;
    }
}

export default new PermissionService();
